import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MqttComponent } from '@/pages/tools/mqtt/mqtt.component';
import { MQTT_SERVICE } from 'src/api/mqtt';
import { CloudMqttService } from '@/cloud/services/cloud-mqtt.service';
import { DeviceContextService } from '../device-context.service';

/**
 * Cloud wrapper for the MQTT tool: the processor's MQTT connection and live messages, relayed over the
 * device tunnel and provided to the shared MqttComponent through MQTT_SERVICE. The header comes from
 * the Device shell.
 */
@Component({
    selector: 'app-cloud-mqtt',
    standalone: true,
    imports: [MqttComponent],
    template: `
        @if (ready()) {
            <app-mqtt [showHeader]="false" />
        }
    `,
    styles: [
        `
            :host {
                display: flex;
                flex-direction: column;
                flex: 1;
                min-height: 0;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [CloudMqttService, { provide: MQTT_SERVICE, useExisting: CloudMqttService }]
})
export class CloudMqttComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private deviceCtx = inject(DeviceContextService);
    private mqttService = inject(CloudMqttService);

    ready = signal(false);

    ngOnInit(): void {
        const deviceId = this.route.snapshot.paramMap.get('deviceId') ?? this.route.parent?.snapshot.paramMap.get('deviceId') ?? this.deviceCtx.device()?.id ?? '';
        if (deviceId) {
            this.mqttService.setDeviceId(deviceId);
            this.ready.set(true);
        }
    }
}
